import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import './css/impressao.css';
import API from '../../../actions/api-helper';
import UI from '../../../actions/ui-helper';
import DataUtil from '../../../actions/data.js';
import StringUtil from '../../../actions/string.js';

class ImpressaoResumo extends Component {
  constructor(props) {
    super(props);
    this.state = false;
    if (this.props.location) {
      this.state = this.props.location.state;
    }
  }

  componentDidMount() {
    if (!this.state) return;
    UI.loader('show', 'Aguarde, gerando relatório...');
    API.post('/apuracao', this.state)
      .then(
        function(json) {
          this.setState(json.data);
          UI.loader('hide');
        }.bind(this),
      )
      .catch(function(json) {
        UI.alert(false, json.message);
      });
  }

  render() {
    if (!this.state) {
      this.props.history.push('/apuracao');
      return false;
    }
    if (!this.state.codigos) {
      return false;
    }

    let usuarioStyle = { width: '40%' };
    let valorStyle = { textAlign: 'right' };
    let vinculoStyle = { /*whiteSpace: "nowrap",*/ textAlign: 'right' };

    // Configurações do relatório
    let totalId = this.state.codigos.length - 1;
    let total = this.state.codigos[totalId];
    let linhas = total.usuarios;

    // Dados do cabeçalho
    let empresa = this.props.usuario.empresa;
    let endereco = this.props.usuario.empresa.endereco;

    // Renderização da tabela
    return (
      <div className="report">
        <button className="btn btn-primary btn-float-right" onClick={() => window.print()}>
          <i className="icon icon-printer" />
          Preparar para Impressão
        </button>
        <header className="report-header">
          <h2>{empresa.razaoSocial}</h2>
          <h3>CNPJ: {empresa.cnpj}</h3>
          <h4>
            {endereco.logradouro} {endereco.numero} - {endereco.bairro} - cep {endereco.cep} -{' '}
            {endereco.cidade} - {endereco.estado}
          </h4>
          <h3>RELATÓRIO DE PRODUÇÃO - {DataUtil.mesPorExtenso(this.state.periodoDe)}</h3>
        </header>
        <hr />
        <div className="report-content">
          <table className="report-table stretch">
            <thead>
              <tr>
                <th style={usuarioStyle}>Profissional</th>
                <th>Horas</th>
                {this.props.usuario.perfil !== 2 && (
                  <React.Fragment>
                    <th>R$ / Hora</th>
                    <th>Custo (À PAGAR)</th>
                    <th>Vínculo</th>
                  </React.Fragment>
                )}
              </tr>
            </thead>
            <tbody>
              {linhas.map((linha, idx) => {
                let valorHora = linha.total / (linha.minutos / 60);
                valorHora = isNaN(valorHora) ? '0.00' : valorHora.toFixed(2);
                return (
                  <tr key={idx}>
                    <td>{linha.nome}</td>
                    <td style={valorStyle}>{DataUtil.formatarHora(linha.minutos)}</td>
                    {this.props.usuario.perfil !== 2 && <td style={valorStyle}>{valorHora}</td>}
                    {this.props.usuario.perfil !== 2 && (
                      <td style={valorStyle}>R$ {linha.total.toFixed(2).replace('.', ',')}</td>
                    )}
                    {this.props.usuario.perfil !== 2 && (
                      <td style={vinculoStyle}>{StringUtil.nomeVinculo(linha.vinculo)}</td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <br />
        </div>
        <footer className="report-footer">
          <span id="pageCount" />
        </footer>
      </div>
    );
  }
}

export default withRouter(ImpressaoResumo);
